import { createFileRoute } from "@tanstack/react-router";

// The Dutch path the first password mails used (until 30-09-2026): on to /password with the token.
export const Route = createFileRoute("/wachtwoord")({
  beforeLoad: () => {
    window.location.replace(`/password${window.location.hash}`);
  },
  component: () => null,
});
